module.exports = __webpack_public_path__ + "img/accounts.62250489.svg";